import React from 'react';
import useOFLExperiment from '@lo/shared/hooks/useOFLExperiment';
import { safeLazy } from '@lo/shared/helpers/safeDynamicImport';

const TrainingLayout = safeLazy(() => import('./Training'));

const Training: React.FC = () => {
    const { isOFL, isLoading } = useOFLExperiment();

    if (isLoading) return null;

    return isOFL ? <TrainingLayout /> : null;
};

export default Training;
